module.exports = __webpack_public_path__ + "static/img/24.05c3622.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/csfish/24.png
// module id = wgkT
// module chunks = 0